// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3y5bW","inner":"Form_inner__38-Ov","range":"Form_range__2o4nB","name":"Form_name__2yt2t","actions":"Form_actions__-UAgr"};